export const noop = ()=>{};
export const calculateCanEditContact = (existingContact)=>{
    if (existingContact == null) return false;
    return !existingContact.isSample();
};
export const contactHasOtherActiveAgreements = (existingContact)=>{
    if (existingContact == null) return false;
    return existingContact.hasSignedAgreements();
};
export const handlePickerChange = async (param)=>{
    let { change, onChange, onValidation, getProps } = param;
    switch(change.type){
        case 'initial':
            onValidation(true);
            onChange({
                type: 'noContact'
            });
            return;
        case 'existingContact':
            onValidation(true);
            onChange({
                type: 'existingContact',
                id: change.id
            });
            return;
        case 'newContact':
            {
                const saved = await getProps().openContactModal({});
                await getProps().newContactPostActions(saved);
                return;
            }
        case 'sampleContact':
            onValidation(true);
            onChange({
                type: 'sampleContact'
            });
    }
};
